module.exports = __webpack_public_path__ + "img/aws.e14018ee.png";